<div class="pageId_Home biggerFont" xmlns:margin-left="http://www.w3.org/1999/xhtml">
  <div *transloco="let t">
    <mat-card class="p-0 lazy-loading-min-height-500">
      <div id="home">
        <app-dynamic-image [mode]="'FLEX'">
          <div class="flex-container">
            <div class="banner-main-container">
              <div class="banner-new-product btn-primary-kw" (click)="scroll(sectionId_effortplanner)">
                <span class="new-product-circle-banner" [innerHTML]="t('products.banner.new')"></span>
              </div>

              <a
                class="digital-badge digital-badge-regular"
                href="https://www.digitalrealestate.ch/top-10-digital-real-estate-projekte-2023/"
                target="_blank"
              >
                <img class="digital-badge-img" src="/assets/images/digital-top-4.png" />
              </a>

              <a
                class="digital-badge digital-badge-long"
                href="https://www.digitalrealestate.ch/top-10-digital-real-estate-projekte-2022/"
                target="_blank"
              >
                <img class="digital-badge-img" src="/assets/images/banners/digital-realestate-2022.svg" />
              </a>
            </div>

            <h1 class="bannerTitle" data-translate="banner.genericTitle">{{ t("products.banner.genericTitle") }}</h1>
            <h1 class="bannerTitle" data-translate="banner.genericTitle2">{{ t("products.banner.genericTitle2") }}</h1>
            <h3 class="bannerTitle" data-translate="banner.genericTitle3">{{ t("products.banner.genericTitle3") }}</h3>

            <div style="margin-top: 20px; text-align: left">
              <button
                *ngIf="!isAuthenticated"
                style="border-top: 3px solid; border-left: 3px solid; border-right: 3px solid; border-bottom: 3px solid"
                class="btn btn-elegant-white-title btn-elegant-white btn-xlg"
                [routerLink]="'7tage'"
              >
                {{ t("products.use_free_month") }}
              </button>
            </div>
          </div>
        </app-dynamic-image>
      </div>
    </mat-card>

    <!--Quick Navigation-->
    <mat-card class="p-0 lazy-loading-min-height-100">
      <mat-card-content class="contact-container" style="padding: 0">
        <!-- <mat-card-title>Landing page for keevalue.</mat-card-title> -->
        <ul class="nav nav-pills nav-justified kv-nav">
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              anchor-smooth-scroll="sectionId_baukosten"
              role="tab"
              (click)="scroll(sectionId_baukosten)"
            >
              <img src="/assets/images/products/baukosten_termine.svg" />
              <figcaption>{{ t("products.start.quickNav.build") }}</figcaption>
            </a>
          </li>
          <ng-container *ngIf="hasInsuranceValues">
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" (click)="scroll(sectionId_versicherungswerte)" role="tab">
                <img src="/assets/images/products/versicherungswerte.svg" />
                <figcaption>
                  {{ t("products.start.quickNav.insuranceValue") }}
                </figcaption>
              </a>
            </li>
          </ng-container>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" (click)="scroll(sectionId_umbaukosten)">
              <img src="/assets/images/products/rebuild_costs.svg" />
              <figcaption>{{ t("products.start.quickNav.rebuild") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" (click)="scroll(sectionId_betriebskosten)">
              <img src="/assets/images/products/betriebskosten.svg" />
              <figcaption>{{ t("products.start.quickNav.bewk") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" (click)="scroll(sectionId_lcc)">
              <img src="/assets/images/products/lebenszyklus.svg" />
              <figcaption>{{ t("products.start.quickNav.lcc") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" (click)="scroll(sectionId_dienstleistungen)">
              <img src="/assets/images/products/dienstleistungen.svg" />
              <figcaption>{{ t("products.start.quickNav.services") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" role="tab" (click)="scroll(sectionId_about)">
              <img style="padding: 12px" src="/assets/images/logo_kennwerte.svg" />
              <figcaption>{{ t("products.start.quickNav.about") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scroll(sectionId_userfeedback)">
              <img src="/assets/images/prices/userfeedback.svg" />
              <figcaption>{{ t("products.start.quickNav.userfeedback") }}</figcaption>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              role="tab"
              anchor-smooth-scroll="sectionId_prices"
              role="tab"
              (click)="scroll(sectionId_prices)"
            >
              <img src="/assets/images/prices/einmalige_berechnung.svg" />
              <figcaption>{{ t("products.start.quickNav.prices") }}</figcaption>
            </a>
          </li>
        </ul>
      </mat-card-content>
    </mat-card>

    <!-- START CONTENT -->
    <ng-container #sectionId_webinar id="sectionId_webinar" class="lazy-loading-min-height-600">
      <app-webinar></app-webinar>
    </ng-container>
    <ng-container #sectionId_intro id="sectionId_intro" class="lazy-loading-min-height-500">
      <app-intro [isAuthenticated]="isAuthenticated"></app-intro>
    </ng-container>

    <!-- Content Bar :) - Modul Effort planner rechner -->
    <div
      #sectionId_effortplanner
      id="sectionId_effortplanner"
      fragment="effortplanner"
      class="lazy-loading-min-height-500"
    >
      <app-effortplanner
        [isAuthenticated]="isAuthenticated"
        [hasEffortPlanner]="hasEffortPlanner"
        (openBillingModal)="openBillingModal($event)"
      ></app-effortplanner>
    </div>

    <!-- Content Bar 01 - Modul LCA rechner -->
    <div #sectionId_lca id="sectionId_lca" fragment="lca" class="lazy-loading-min-height-500">
      <app-lca
        [isAuthenticated]="isAuthenticated"
        [hasLcaCosts]="hasLcaCosts"
        (openBillingModal)="openBillingModal($event)"
      ></app-lca>
    </div>

    <!-- Content Bar 00 - Modul Planungsgrundlage -->
    <div #sectionId_pf id="sectionId_pf" fragment="pf" class="lazy-loading-min-height-500">
      <app-pf
        [isAuthenticated]="isAuthenticated"
        [hasModule]="hasPlanningFondations"
        (openBillingModal)="openBillingModal($event)"
      ></app-pf>
    </div>

    <!-- Content Bar 02 - Modul LCC -->
    <div #sectionId_lcc id="sectionId_lcc" fragment="lcc" class="lazy-loading-min-height-600">
      <app-lcc
        [isAuthenticated]="isAuthenticated"
        [hasLccCosts]="hasLccCosts"
        (openBillingModal)="openBillingModal($event)"
      ></app-lcc>
    </div>

    <!-- Content Bar 03 - Modul Neubaukostenrechner -->
    <div #sectionId_baukosten id="sectionId_baukosten" class="lazy-loading-min-height-500">
      <app-build
        [IsAuthenticated]="isAuthenticated"
        [hasBuildingCosts]="hasBuildingCosts"
        (openBillingModal)="openBillingModal($event)"
      ></app-build>
    </div>

    <!-- Content Bar 04 - Modul Umbaukosten -->
    <div #sectionId_umbaukosten id="sectionId_umbaukosten" class="lazy-loading-min-height-500">
      <app-rebuild
        [isAuthenticated]="isAuthenticated"
        [hasRebuildCosts]="hasRebuildCosts"
        (openBillingModal)="openBillingModal($event)"
      ></app-rebuild>
    </div>

    <!-- Content Bar 05 - Versicherungswerte -->
    <div #sectionId_versicherungswerte id="sectionId_versicherungswerte">
      <app-insurance [isAuthenticated]="isAuthenticated" [hasInsuranceCosts]="hasInsuranceValues"></app-insurance>
    </div>

    <!-- Content Bar 04 - bewk + pom+-->
    <div #sectionId_betriebskosten id="sectionId_betriebskosten" class="lazy-loading-min-height-600">
      <app-bewk
        [isAuthenticated]="isAuthenticated"
        [hasOperationalCosts]="hasOperationalCosts"
        (openBillingModal)="openBillingModal($event)"
      ></app-bewk>
    </div>

    <!-- Content Bar 05 - Dienstleistungen -->
    <div
      #sectionId_dienstleistungen
      id="sectionId_dienstleistungen"
      ng-include="'app/website_fragments/products/services.html'"
    >
      <app-services></app-services>
    </div>

    <!-- Content Bar 04 - About Us -->
    <!-- <div id="sectionId_about"></div>
      <div ui-view="about_us"></div> -->
    <div #sectionId_about id="sectionId_about">
      <app-about-us></app-about-us>
    </div>

    <ng-container> <app-team></app-team> </ng-container>

    <!-- Content Bar 05 - User Feedback -->
    <!-- <div id="sectionId_userfeedback"></div> -->
    <div #sectionId_userfeedback id="sectionId_userfeedback" class="sectionId_userfeedback sectionAnchor flexBoxOuter">
      <div class="flexBoxInner txt marginRight" style="hyphens: auto">
        <div style="margin-bottom: 26px">
          <h4>{{ t("products.start.quickNav.userfeedback") }}</h4>
        </div>
        <div>
          <h3 class="kennwertered" data-translate="userfeedback.headline">{{ t("products.userfeedback.headline") }}</h3>
        </div>
        <div class="ctPartImg" ng-style="ctPartImgStyle">
          <div class="cImage" id="cImage" style="height: 100px; display: inline-flex">
            <img
              style="height: 100px; width: 100px; float: left; vertical-align: center"
              class=""
              id="userImage"
              src="/assets/images/user-feedback/rb.jpg"
            />
            <p
              style="
                height: 100%;
                width: 50%;
                padding-top: 15px;
                padding-left: 5px;
                padding-right: 5px;
                display: inline-block;
              "
            >
              <label style="margin-bottom: 0px" data-translate="userfeedback.user">
                {{ t("products.userfeedback.user") }}</label
              >
              <br />
              <label class="clearLabel" data-translate="userfeedback.title">
                {{ t("products.userfeedback.title") }}</label
              >
              <label class="clearLabel" data-translate="userfeedback.position">
                {{ t("products.userfeedback.position") }}</label
              >
            </p>
            <div style="line-height: 100px; height: 100px; display: inline-block">
              <img
                id="userLogo"
                style="height: 35px; padding-bottom: 5px; border-radius: 0%; vertical-align: middle"
                src="/assets/images/user-feedback/logo.jpg"
              />
            </div>
          </div>
        </div>

        <div class="brightfont clearFloat">
          <p
            style="margin-top: 20px"
            data-translate="userfeedback.text1"
            [innerHTML]="t('products.userfeedback.text1')"
          ></p>
          <p
            style="margin-top: 20px"
            data-translate="userfeedback.text2"
            [innerHTML]="t('products.userfeedback.text2')"
          ></p>
        </div>
      </div>
      <div class="flexBoxInner img">
        <div class="centerImage centerImgVertically">
          <img id="userBuilding" src="/assets/images/user-feedback/gebaeude.jpg" style="align-self: center" />
        </div>
      </div>
      <!--<div class="img">-->
      <!--<img src="/assets/images/user-feedback/gebaeude.jpg" style="align-self: center; height: 600px;border-radius: 180px 0 0 180px;">-->
      <!--</div>-->
    </div>

    <mat-card id="sectionId_userfeedback2" class="info-section">
      <div class="sectionId_userfeedback2 flexBoxOuter">
        <div class="flexBoxInner img marginRight">
          <div class="centerImage center-img-box">
            <img src="/assets/images/user-feedback/2/gebaeude-small.jpg" />
          </div>
        </div>
        <div class="flexBoxInner txt marginRight align-inner">
          <div class="">
            <div>
              <mat-card-title class="keevalue-title kv-text-color">
                {{ t("products.userfeedback.2.headline") }}
              </mat-card-title>
            </div>
            <!-- <div>
                <mat-card-title class="sub-title kv-text-color"> {{ t('products.userfeedback.headline') }}
                </mat-card-title>
              </div> -->
            <div class="part-img-wrapper">
              <div class="kv-Image">
                <img class="user-img" id="userImage" src="/assets/images/user-feedback/2/am.jpg" />
                <p class="kv-inner-wrapper">
                  <label>{{ t("products.userfeedback.2.user") }}</label>
                  <label class="clearLabel">{{ t("products.userfeedback.2.title") }}</label>
                  <label class="clearLabel">{{ t("products.userfeedback.2.position") }}</label>
                </p>
                <div class="user-logo-box">
                  <img id="userLogo" class="userLogo" src="/assets/images/user-feedback/2/logo.png" />
                </div>
              </div>
            </div>
            <div class="baukosten-box mt-3">
              <p class="brightfont" [innerHtml]="t('products.userfeedback.2.text1')"></p>
              <p class="brightfont d-inline hyphen mt-3" [innerHtml]="t('products.userfeedback.2.text2')"></p>
            </div>
          </div>
        </div>
      </div>
    </mat-card>

    <ng-container>
      <app-reference></app-reference>
    </ng-container>

    <!-- Content Bar 06 - Beirat-->
    <!-- <div id="sectionId_advisoryboard"></div> -->
    <!--    <div #sectionId_advisoryboard id="sectionId_advisoryboard" ui-view="advisory_board">-->
    <!--      <app-advisory-board></app-advisory-board>-->
    <!--    </div>-->

    <!-- Content Bar 06 - Prices -->
    <!-- <div id="sectionId_prices"></div> -->
    <div #sectionId_prices id="sectionId_prices">
      <app-prices [showBuildingCosts]="showBuildingCosts" [backGroundColor]="'section-grey-color'"></app-prices>
    </div>
    <!-- STOP CONTENT -->
  </div>
</div>

<div class="kv-contact-btn floating-buttons" *transloco="let t">
  <!--Jobs -->
  <div class="kv-contact-demo-btn">
    <a mat-button style="width: 100%" class="btn btn-xlg btn-primary-kv" href="/jobs">{{ t("global.footer.jobs") }}</a>
  </div>
  <!-- Book a Demo button -->
  <div class="kv-contact-demo-btn">
    <a mat-button style="width: 100%" class="btn btn-xlg btn-primary-kv" href="/demo">{{ t("global.footer.demo") }}</a>
  </div>
  <!-- Contact button -->
  <div class="kv-contact-demo-btn">
    <a mat-button style="width: 100%" class="btn btn-xlg btn-primary-kv" href="/contact">{{
      t("global.footer.contact")
    }}</a>
  </div>
</div>
